(function () {
  'use strict'

  // Init Aos Animation
  // ----------------------------------------
  AOS.init({
    once: true,
    disable: function () {
      const isMobile = /mobile|tablet|ip(ad|hone|od)|android/i.test(navigator.userAgent);
      const hasApiBlock = $('.block-api_documentation').length > 0;
      
      return isMobile || hasApiBlock;
    }
  })

  // Copy to clipboard
  // ----------------------------------------
  window.copyToClipboard = function ( clipboardText, el ) {
    const originalTooltip = el.getAttribute( 'tooltip' )

    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(clipboardText)
    } else {
        let $textarea = $('<textarea>')
        $textarea.val(clipboardText)
        $('body').append($textarea)
        $textarea[0].select()
        document.execCommand('copy')
        $textarea.remove()
    }
    
    el.setAttribute( 'tooltip', 'Kopiert' )

    setTimeout(() => {
      el.setAttribute( 'tooltip', originalTooltip )
    }, 5000)
  }  

  // Smooth Scroll
  // ----------------------------------------
  SmoothScroll('a[href*="#"]', {
    speed: 600,
    topOnEmptyHash: false,
    updateURL: false,
    offset: 100
  })
})()